import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { USER_ROLES, USER_STATUS } from 'src/app/enums/enums';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
declare var $: any;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  public identity:      any;
  public token:         string;
  public status:        string;
  public user:          User;
  public newsRoles:     string[];
  public plenaryRoles:  string[];
  public usersRoles:    string[];
  public role:          USER_ROLES;
  public loading:       boolean = false;

  constructor(private _userService: UserService, private _router: Router) {
    this.user = new User('', '', '', '', '', USER_ROLES.ADMIN, USER_STATUS.ACTIVE);
    this.newsRoles = [
      USER_ROLES.ADMIN,
      USER_ROLES.COMUNICATIONS,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.SYSTEMS,
    ];
    this.plenaryRoles = Array.from(this.newsRoles);
    this.usersRoles = [
      USER_ROLES.ADMIN,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.SYSTEMS,
    ];
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token    = this._userService.getToken();
    if (!this.identity || !this.token) {
      this._router.navigate(['/iniciar-sesion']);
    } else {
      this.getLoggedUser();
    }
  }

  getLoggedUser:() => void = () => {
    this.loading = true;
    this._userService.getLoggedUser(this.identity.id).subscribe(
      res => {
        if (!res.user) {
          this.status = 'error';
        } else {
          this.user = res.user;
          this.status = 'ok';
          this.role = this.user.role;
        }
        this.loading = false;
      },
      err => this.onError(err)
    );
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/iniciar-sesion']);
  }

  validateRoles(roles: string[], role: USER_ROLES): boolean {
    return roles.includes(role);
  }

  onError(error: any): void {
    let errorMessage = error;
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
  }
}
